export default __webpack_public_path__ + "static/media/ios.be0b82ab.svg";